import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsThree3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBarsThree3"><Path d="M2.5 12H13.5M2.5 5.5H21.5M2.5 18.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBarsThree3;
